import {Component, Input} from '@angular/core';
import {AsiDialogView} from "@asi-ngtools/lib";
import {
  DossierBloqueDto,
  FileProperties,
  IDossierWebServiceClient,
  ResultFixedAnomaliesDto,
  DocumentInformation
} from "@resources/resources";
import {EtatEnums} from "@common/enum/Etat.enum";
import {UserStore} from "@digicerba/common";
import {TranslateService} from "@ngx-translate/core";
import {TypeAnomalies} from "@common/constants/TypeAnomalie";

@Component({
  selector: 'dialog-donnees-manquantes',
  templateUrl: './donnees-manquantes-component-dialog.component.html'
})

export class DonneesManquantesComponent extends AsiDialogView {

  readonly VISA_MAX_LENGTH = 2;
  dossierBloquesDTOs: Array<DossierBloqueDto> = [];
  numeroDossier: string;
  prenomNom: string;
  nom: string;
  prenom: string;
  dateDeNaissance: string;
  apiResult: ResultFixedAnomaliesDto;
  waiting :boolean = false;
  isChampsValides : boolean = false;
  shouldRefreshDossiers: boolean = false;
  documentInformations: Array<DocumentInformation> = [];
  showSendButton: boolean = false;
  nbModifiedAValider: number = 0;
  hasNonDiscordantField: boolean;
  isVisaRequired: boolean;
  isVisaMissing: boolean;


  @Input() tab: string;
  @Input() fileProperties: FileProperties;
  @Input() status: EtatEnums;

  constructor(private dossierWebServiceClient: IDossierWebServiceClient,
              private translator: TranslateService,
              private userStore: UserStore) {
    super();
  }

  ngOnInit() {
    this.hasNonDiscordantField = false;
    this.isVisaRequired = false;
    this.isVisaMissing = true;
    this.dossierWebServiceClient.getDetailsByNumeroDossierAndEtat(this.numeroDossier, EtatEnums.EN_COURS.value()).subscribe(
      dossiersBloques => {
        if (dossiersBloques != undefined) {
          this.dossierBloquesDTOs.push(...dossiersBloques);

          // Extract anomalies types and set default tab
          if (!this.tab) {
            const types = Array.from(new Set(dossiersBloques.map(item => item.typeAnomalie)));
            this.tab = types.length > 1 ? 'RESULTATS' : types[0];
          }
        }
      }
    );
  }

  // State management
  isEtatTermine() {
    return this.status.value() == EtatEnums.TERMINE.value();
  }
  isEtatEnCours() {
    return this.status.value() == EtatEnums.EN_COURS.value();
  }
  isEtatAValider() {
    return this.status.value() == EtatEnums.A_VALIDER.value();
  }
  shouldRefresh() {
    this.shouldRefreshDossiers = true;
  }

  // Tab management
  setTab(tab: string) {
    this.tab = tab;
  }
  getDocumentsAnomalies() {
    return this.dossierBloquesDTOs.filter(d => d.typeAnomalie == TypeAnomalies.DOCUMENTS);
  }
  getResultatsAnomalies() {
    return this.dossierBloquesDTOs.filter(d => d.typeAnomalie == TypeAnomalies.RESULTATS);
  }
  getResultatLabelTab(): string {
    return this.isEtatEnCours()
      ? this.translator.instant('MODAL.DONNEES_MANQUANTES.tab_donnees_a_saisir')
      : this.translator.instant('MODAL.DONNEES_MANQUANTES.tab_donnees_saisie');
  }
  getDocumentsLabelTab(): string {
   return this.isEtatEnCours()
      ? this.translator.instant('MODAL.DONNEES_MANQUANTES.tab_documents_fournir')
      : this.translator.instant('MODAL.DONNEES_MANQUANTES.tab_documents_fournis');
  }

  masquerReturnMessageApresAffichage(data: DossierBloqueDto){
    if(this.hasValidationResult()){
      this.apiResult.validationResults.forEach(result =>{
        if( result.anomalyFix.cleLigneAnalyseResultat == data.cleLigneAnalyseResultat && result.returnMessage != ''){
          result.returnMessage = '';
        }
      });
    }
  }

  setData(data: DossierBloqueDto) {
    this.masquerReturnMessageApresAffichage(data);
    this.dossierBloquesDTOs.map((dto) => {
      if (dto.cleLigneAnalyseResultat == data.cleLigneAnalyseResultat) {
        dto.resultatAnalyseSaisie = data.resultatAnalyseSaisie;
      }
    });
  }

  setVisaMissing(event: Event): void {
    const visaValue = (event.target as HTMLInputElement).value;

    if (visaValue !== '' && visaValue.length >= this.VISA_MAX_LENGTH) {
      this.isVisaMissing = false;
    } else {
      this.isVisaMissing = true;
    }
  }

  hasChampsValides(isValide : boolean){
    this.dossierBloquesDTOs.forEach(e => {
      if (e.resultatAnalyseConfirm === true) {
        this.hasNonDiscordantField = true;
      }
    });
    this.isChampsValides = isValide;
  }

  hasVisaRequired(isRequired: boolean) {
    this.isVisaRequired = isRequired;
  }

  //TODO onglet document à ajouter
  hasDocuments() {
    return false;
  }

  hasValidationResult(){
    if(this.apiResult == null ||this.apiResult == undefined )
      return false ;
    if(this.apiResult.validationResults == null ||this.apiResult.validationResults == undefined )
      return false ;
    return true;
  }

  hasValidationResultKO(){
    return this.hasValidationResult() && this.apiResult.validationResults.filter(value => value.statusCode == 'KO').length > 0 ;
  }


  closeWhenNoStatusKO(){
    if(!this.hasValidationResultKO())
    {
        this.dialog.close(String(0));
    }
  }

  praparerDossierBloquersDtos(){
   this.dossierBloquesDTOs.map((d) => {
     if( d.resultatAnalyseSaisie == null || d.resultatAnalyseSaisie == "" ){
       d.resultatAnalyseSaisie = "missed";
     }
     d.codeCorrespondantSaisie = this.userStore.getLogin();
   });
 }

  fixerAnomalies( nonMissedDossiersBloques : DossierBloqueDto[]){
    this.waiting = true ;
    const visaInput = document.getElementById('visa') as HTMLInputElement;
    const visaValue = visaInput.value;

    if (visaValue !== '') {
      this.dossierBloquesDTOs.forEach(e => {
        e.visa = visaValue;
      });
    }
    this.dossierWebServiceClient.fixerAnomalies(nonMissedDossiersBloques)
      .subscribe((apiResult) =>{
        if(apiResult !== undefined)
          this.apiResult = apiResult;
        this.waiting = false;
        this.closeWhenNoStatusKO();
      },(err) => {
        let error;
        if(err.status ==  400) {
          error = this.translator.instant('PAGE.SERVEUR-RESULTATS.DIALOG.DONNEES_MANQUANTES.erreur_bad_request');
        }else{
          error = this.translator.instant('PAGE.SERVEUR-RESULTATS.DIALOG.DONNEES_MANQUANTES.erreur_fixed_anomalies');
        }
        this.waiting=false;

        window.alert(error);
      });
    this.refreshDossierBloque();
    if (this.getResultatsAnomalies().length == 0) {
      if (this.getDocumentsAnomalies().length == 0) {
        this.closeDialog();
      } else if (this.getDocumentsAnomalies().length == 0) {
        this.setTab('DOCUMENTS');
      }
    }
  }

   sendData()  {
    this.praparerDossierBloquersDtos();
    let nonMissedDossiersBloques : DossierBloqueDto[] = this.dossierBloquesDTOs.filter( e => e.resultatAnalyseSaisie != 'missed');
    nonMissedDossiersBloques = nonMissedDossiersBloques.filter(e => e.resultatAnalyseConfirm == true);
    if( nonMissedDossiersBloques.length > 0 ){
       this.fixerAnomalies(nonMissedDossiersBloques);
    }
  }

  sendDocument() {
    if (this.nbDocumentsAnomaliesToFix() == 0) {
      if (this.getResultatsAnomalies().length > 0) {
        this.refreshDossierBloque();
        this.setTab('RESULTATS');
      } else if (this.getResultatsAnomalies().length == 0) {
        this.closeDialogDocuments();
      }
    } else if (this.nbDocumentsAnomaliesToFix() > 0) {
      this.showSendButton = false;
      this.refreshDossierBloque();
    }
    this.documentInformations = [];
  }

  refreshDossierBloque() {
    this.dossierBloquesDTOs = [];
    this.dossierWebServiceClient.getDetailsByNumeroDossierAndEtat(this.numeroDossier, this.status.value()).subscribe(
      dossiersBloques => {
        if (dossiersBloques != undefined) {
          this.dossierBloquesDTOs.push(...dossiersBloques);
        }
      }
    );
  }

  nbDocumentsAnomaliesToFix() {
    return this.getDocumentsAnomalies().length - this.getNbFixedDocuments();
  }

  deleteDocumentInfo(documentInformation: DocumentInformation) {
    for (let i = 0; i < this.documentInformations.length; i ++ ) {
      let documentInfo = this.documentInformations[i];
      if (documentInfo.numeroDossier === documentInformation.numeroDossier
        && documentInfo.cleLigneAnalyseResultat === documentInformation.cleLigneAnalyseResultat
        && documentInfo.codeCorrespondant === documentInformation.codeCorrespondant) {
        this.documentInformations.splice(i, 1);
        break;
      }
    }
  }

  addDocumentInfo(documentInformation: DocumentInformation) {
    let infoExist = false;
    for (let i = 0; i < this.documentInformations.length; i ++ ) {
      let documentInfo = this.documentInformations[i];
      if (documentInfo.numeroDossier === documentInformation.numeroDossier
        && documentInfo.cleLigneAnalyseResultat === documentInformation.cleLigneAnalyseResultat
        && documentInfo.codeCorrespondant === documentInformation.codeCorrespondant) {
        infoExist = true;
        break;
      }
    }
    if (infoExist == false) {
      this.documentInformations.push(documentInformation);
    }
  }

  addOrDeleteDocumentInfoInput(documentInformation: DocumentInformation) {
    if (documentInformation.action === 'ADD') {
      this.addDocumentInfo(documentInformation);
    } else if (documentInformation.action === 'DELETE') {
      this.deleteDocumentInfo(documentInformation);
    }

    if (this.getNbFixedDocuments() > 0) {
      this.showSendButton = true;
    } else {
      this.showSendButton = false;
    }
  }

  getNbFixedDocuments() {
    return this.documentInformations.length;
  }

  // Dismiss
  closeDialog(){
    if( !this.hasValidationResult())
    {
      this.dialog.close();
    }else{
      let nbDossierKO = 0;
      this.apiResult.validationResults.forEach(res => {
        if(res.statusCode =="KO"){
          nbDossierKO++;
        }
      });
      this.dialog.close(String( nbDossierKO));
    }
  }
  closeDialogDocuments() {
    this.dialog.close(this.shouldRefreshDossiers);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/utils/dialog/dialog-donnees-manquantes/donnees-manquantes-component-dialog.component.ts